/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductFilterChips_ProductTypesQueryVariables = Types.Exact<{
  productTypeIds: Array<Types.Scalars['ID']['input']>;
}>;


export type ProductFilterChips_ProductTypesQuery = { pimProductTypes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimProductTypesResult', productTypes: Array<{ __typename: 'PimProductType', id: string, label: string }> } };

export type ProductFilterChips_SuppliersQueryVariables = Types.Exact<{
  pimSupplierIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
}>;


export type ProductFilterChips_SuppliersQuery = { pimSearchSuppliers: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchSuppliersResult', suppliers: Array<{ __typename: 'PimSupplier', id: string, title: string }> } };

export type ProductFilterChips_PropertyTypesQueryVariables = Types.Exact<{
  propertyTypeKeys: Array<Types.Scalars['String']['input']>;
}>;


export type ProductFilterChips_PropertyTypesQuery = { pimPropertyTypes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimPropertyTypesResult', propertyTypes: Array<{ __typename: 'PimPropertyType', id: string, key: string, label: string }> } };

export type ProductFilterChips_PropertyTypeValuesQueryVariables = Types.Exact<{
  propertyTypeValueKeys: Array<Types.Scalars['String']['input']>;
}>;


export type ProductFilterChips_PropertyTypeValuesQuery = { pimPropertyTypeValues: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimPropertyTypeValuesResult', propertyTypeValues: Array<{ __typename: 'PimPropertyTypeValue', id: string, key: string, label: string }> } };

export type ProductFilterChips_SupplierCataloguesByIdsQueryVariables = Types.Exact<{
  supplierCatalogueIds: Array<Types.Scalars['ID']['input']>;
  filters?: Types.InputMaybe<Types.PimSearchSupplierCataloguesFilters>;
}>;


export type ProductFilterChips_SupplierCataloguesByIdsQuery = { pimGetSupplierCataloguesByIds: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchSupplierCataloguesResult', supplierCatalogues: Array<{ __typename: 'PimSupplierCatalogue', id: string, title: string }> } };


export const ProductFilterChips_ProductTypesDocument = gql`
    query ProductFilterChips_ProductTypes($productTypeIds: [ID!]!) {
  pimProductTypes(ids: $productTypeIds) {
    ... on PimProductTypesResult {
      productTypes {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useProductFilterChips_ProductTypesQuery__
 *
 * To run a query within a React component, call `useProductFilterChips_ProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFilterChips_ProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFilterChips_ProductTypesQuery({
 *   variables: {
 *      productTypeIds: // value for 'productTypeIds'
 *   },
 * });
 */
export function useProductFilterChips_ProductTypesQuery(baseOptions: Apollo.QueryHookOptions<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables> & ({ variables: ProductFilterChips_ProductTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables>(ProductFilterChips_ProductTypesDocument, options);
      }
export function useProductFilterChips_ProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables>(ProductFilterChips_ProductTypesDocument, options);
        }
export function useProductFilterChips_ProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables>(ProductFilterChips_ProductTypesDocument, options);
        }
export type ProductFilterChips_ProductTypesQueryHookResult = ReturnType<typeof useProductFilterChips_ProductTypesQuery>;
export type ProductFilterChips_ProductTypesLazyQueryHookResult = ReturnType<typeof useProductFilterChips_ProductTypesLazyQuery>;
export type ProductFilterChips_ProductTypesSuspenseQueryHookResult = ReturnType<typeof useProductFilterChips_ProductTypesSuspenseQuery>;
export type ProductFilterChips_ProductTypesQueryResult = Apollo.QueryResult<ProductFilterChips_ProductTypesQuery, ProductFilterChips_ProductTypesQueryVariables>;
export const ProductFilterChips_SuppliersDocument = gql`
    query ProductFilterChips_Suppliers($pimSupplierIds: [ID!]) {
  pimSearchSuppliers(limit: 0, filters: {pimSupplierIds: $pimSupplierIds}) {
    ... on PimSearchSuppliersResult {
      suppliers {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useProductFilterChips_SuppliersQuery__
 *
 * To run a query within a React component, call `useProductFilterChips_SuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFilterChips_SuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFilterChips_SuppliersQuery({
 *   variables: {
 *      pimSupplierIds: // value for 'pimSupplierIds'
 *   },
 * });
 */
export function useProductFilterChips_SuppliersQuery(baseOptions?: Apollo.QueryHookOptions<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>(ProductFilterChips_SuppliersDocument, options);
      }
export function useProductFilterChips_SuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>(ProductFilterChips_SuppliersDocument, options);
        }
export function useProductFilterChips_SuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>(ProductFilterChips_SuppliersDocument, options);
        }
export type ProductFilterChips_SuppliersQueryHookResult = ReturnType<typeof useProductFilterChips_SuppliersQuery>;
export type ProductFilterChips_SuppliersLazyQueryHookResult = ReturnType<typeof useProductFilterChips_SuppliersLazyQuery>;
export type ProductFilterChips_SuppliersSuspenseQueryHookResult = ReturnType<typeof useProductFilterChips_SuppliersSuspenseQuery>;
export type ProductFilterChips_SuppliersQueryResult = Apollo.QueryResult<ProductFilterChips_SuppliersQuery, ProductFilterChips_SuppliersQueryVariables>;
export const ProductFilterChips_PropertyTypesDocument = gql`
    query ProductFilterChips_PropertyTypes($propertyTypeKeys: [String!]!) {
  pimPropertyTypes(keys: $propertyTypeKeys) {
    ... on PimPropertyTypesResult {
      propertyTypes {
        id
        key
        label
      }
    }
  }
}
    `;

/**
 * __useProductFilterChips_PropertyTypesQuery__
 *
 * To run a query within a React component, call `useProductFilterChips_PropertyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFilterChips_PropertyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFilterChips_PropertyTypesQuery({
 *   variables: {
 *      propertyTypeKeys: // value for 'propertyTypeKeys'
 *   },
 * });
 */
export function useProductFilterChips_PropertyTypesQuery(baseOptions: Apollo.QueryHookOptions<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables> & ({ variables: ProductFilterChips_PropertyTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables>(ProductFilterChips_PropertyTypesDocument, options);
      }
export function useProductFilterChips_PropertyTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables>(ProductFilterChips_PropertyTypesDocument, options);
        }
export function useProductFilterChips_PropertyTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables>(ProductFilterChips_PropertyTypesDocument, options);
        }
export type ProductFilterChips_PropertyTypesQueryHookResult = ReturnType<typeof useProductFilterChips_PropertyTypesQuery>;
export type ProductFilterChips_PropertyTypesLazyQueryHookResult = ReturnType<typeof useProductFilterChips_PropertyTypesLazyQuery>;
export type ProductFilterChips_PropertyTypesSuspenseQueryHookResult = ReturnType<typeof useProductFilterChips_PropertyTypesSuspenseQuery>;
export type ProductFilterChips_PropertyTypesQueryResult = Apollo.QueryResult<ProductFilterChips_PropertyTypesQuery, ProductFilterChips_PropertyTypesQueryVariables>;
export const ProductFilterChips_PropertyTypeValuesDocument = gql`
    query ProductFilterChips_PropertyTypeValues($propertyTypeValueKeys: [String!]!) {
  pimPropertyTypeValues(keys: $propertyTypeValueKeys) {
    ... on PimPropertyTypeValuesResult {
      propertyTypeValues {
        id
        key
        label
      }
    }
  }
}
    `;

/**
 * __useProductFilterChips_PropertyTypeValuesQuery__
 *
 * To run a query within a React component, call `useProductFilterChips_PropertyTypeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFilterChips_PropertyTypeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFilterChips_PropertyTypeValuesQuery({
 *   variables: {
 *      propertyTypeValueKeys: // value for 'propertyTypeValueKeys'
 *   },
 * });
 */
export function useProductFilterChips_PropertyTypeValuesQuery(baseOptions: Apollo.QueryHookOptions<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables> & ({ variables: ProductFilterChips_PropertyTypeValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables>(ProductFilterChips_PropertyTypeValuesDocument, options);
      }
export function useProductFilterChips_PropertyTypeValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables>(ProductFilterChips_PropertyTypeValuesDocument, options);
        }
export function useProductFilterChips_PropertyTypeValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables>(ProductFilterChips_PropertyTypeValuesDocument, options);
        }
export type ProductFilterChips_PropertyTypeValuesQueryHookResult = ReturnType<typeof useProductFilterChips_PropertyTypeValuesQuery>;
export type ProductFilterChips_PropertyTypeValuesLazyQueryHookResult = ReturnType<typeof useProductFilterChips_PropertyTypeValuesLazyQuery>;
export type ProductFilterChips_PropertyTypeValuesSuspenseQueryHookResult = ReturnType<typeof useProductFilterChips_PropertyTypeValuesSuspenseQuery>;
export type ProductFilterChips_PropertyTypeValuesQueryResult = Apollo.QueryResult<ProductFilterChips_PropertyTypeValuesQuery, ProductFilterChips_PropertyTypeValuesQueryVariables>;
export const ProductFilterChips_SupplierCataloguesByIdsDocument = gql`
    query ProductFilterChips_SupplierCataloguesByIds($supplierCatalogueIds: [ID!]!, $filters: PimSearchSupplierCataloguesFilters) {
  pimGetSupplierCataloguesByIds(
    supplierCatalogueIds: $supplierCatalogueIds
    filters: $filters
  ) {
    ... on PimSearchSupplierCataloguesResult {
      supplierCatalogues {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useProductFilterChips_SupplierCataloguesByIdsQuery__
 *
 * To run a query within a React component, call `useProductFilterChips_SupplierCataloguesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFilterChips_SupplierCataloguesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFilterChips_SupplierCataloguesByIdsQuery({
 *   variables: {
 *      supplierCatalogueIds: // value for 'supplierCatalogueIds'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProductFilterChips_SupplierCataloguesByIdsQuery(baseOptions: Apollo.QueryHookOptions<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables> & ({ variables: ProductFilterChips_SupplierCataloguesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables>(ProductFilterChips_SupplierCataloguesByIdsDocument, options);
      }
export function useProductFilterChips_SupplierCataloguesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables>(ProductFilterChips_SupplierCataloguesByIdsDocument, options);
        }
export function useProductFilterChips_SupplierCataloguesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables>(ProductFilterChips_SupplierCataloguesByIdsDocument, options);
        }
export type ProductFilterChips_SupplierCataloguesByIdsQueryHookResult = ReturnType<typeof useProductFilterChips_SupplierCataloguesByIdsQuery>;
export type ProductFilterChips_SupplierCataloguesByIdsLazyQueryHookResult = ReturnType<typeof useProductFilterChips_SupplierCataloguesByIdsLazyQuery>;
export type ProductFilterChips_SupplierCataloguesByIdsSuspenseQueryHookResult = ReturnType<typeof useProductFilterChips_SupplierCataloguesByIdsSuspenseQuery>;
export type ProductFilterChips_SupplierCataloguesByIdsQueryResult = Apollo.QueryResult<ProductFilterChips_SupplierCataloguesByIdsQuery, ProductFilterChips_SupplierCataloguesByIdsQueryVariables>;